import React, { useState, useEffect } from 'react'
import { FormControlLabel, Switch } from '@mui/material'
import CustomSelect from 'src/components/common/CustomSelect'
import * as PetrolService from 'src/services/PetrolService'
import * as echarts from 'echarts'

const MainPagePetrolECharts = () => {
  const echartsPetrolPrice = 'echarts-petrol-price'
  const echartsPetrolPayment = 'echarts-petrol-payment'
  const [isFilter, setIsFilter] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const [totalPricePayable, setTotalPricePayable] = useState('0.00')
  const [totalPricePayactual, setTotalPricePayactual] = useState('0.00')
  const [yearStart, setYearStart] = useState('')
  const [yearEnd, setYearEnd] = useState('')
  const [yearStartList, setYearStartList] = useState([])
  const [yearEndList, setYearEndList] = useState([])

  useEffect(() => {
    readySetYearStartList()
  }, [])

  useEffect(() => {
    (yearStart || yearEnd) ? readyGetPetrolListByParams() : readyGetPetrolListAll()
    // eslint-disable-next-line
  }, [yearStart, yearEnd])

  const readySetYearStartList = () => {
    const currentYear = new Date().getFullYear()
    const minYear = 2021
    const yearArr = []
    for (let i=minYear; i<=currentYear; i++) {
      yearArr.push({ name: `${i}`, value: i })
    }
    setYearStartList(yearArr)
  }

  const readySetYearEndList = (minYear) => {
    const currentYear = new Date().getFullYear()
    const yearArr = []
    for (let i=minYear; i<=currentYear; i++) {
      yearArr.push({ name: `${i}`, value: i })
    }
    setYearEndList(yearArr)
  }

  const readyGetPetrolListByParams = () => {
    if (!yearStart || !yearEnd) return
    PetrolService.getPetrolListECharts({ yearStart, yearEnd }, getPetrolListEChartsFn)
  }

  const readyGetPetrolListAll = () => {
    PetrolService.getPetrolListECharts({}, getPetrolListEChartsFn)
  }
  const getPetrolListEChartsFn = (resp) => {
    if (resp.success) {
      const list = resp.data.list
      renderEChartsPrice(list)
      renderEChartsPayment(list)
      setTotalCount(resp.data.totalCount)
      setTotalPricePayable(resp.data.totalPricePayable)
      setTotalPricePayactual(resp.data.totalPricePayactual)
    }
  }

  const renderEChartsPrice = (list) => {
    const chartDom = document.getElementById(echartsPetrolPrice)
    const myChart = echarts.init(chartDom)
    const xAxisData = []
    const priceOriginalArr = []
    const priceDiscountArr = []
    list.forEach((item) => {
      xAxisData.push(item.eventDate)
      priceOriginalArr.push(Number(item.priceOriginal))
      priceDiscountArr.push(Number(item.priceDiscount))
    })
    const option = {
      title: { text: '油价曲线' },
      tooltip: { trigger: 'axis' },
      legend: {
        data: ['汽油原价', '汽油折扣价']
      },
      grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: xAxisData
      },
      yAxis: { type: 'value' },
      series: [
        { name: '汽油原价', type: 'line', smooth: true, data: priceOriginalArr },
        { name: '汽油折扣价', type: 'line', smooth: true, data: priceDiscountArr }
      ]
    }
    myChart.setOption(option)
  }

  const renderEChartsPayment = (list) => {
    const chartDom = document.getElementById(echartsPetrolPayment)
    const myChart = echarts.init(chartDom)
    const xAxisData = []
    const pricePayableArr = []
    const pricePayactualArr = []
    list.forEach((item) => {
      xAxisData.push(item.eventDate)
      pricePayableArr.push(Number(item.pricePayable))
      pricePayactualArr.push(Number(item.pricePayactual))
    })
    const option = {
      title: { text: '付款曲线' },
      tooltip: { trigger: 'axis' },
      legend: {
        data: ['应付价格', '实付价格']
      },
      grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: xAxisData
      },
      yAxis: { type: 'value' },
      series: [
        { name: '应付价格', type: 'line', smooth: true, data: pricePayableArr },
        { name: '实付价格', type: 'line', smooth: true, data: pricePayactualArr }
      ]
    }
    myChart.setOption(option)
  }

  const handleSwitchChange = (e) => {
    setIsFilter(e.target.checked)
    if (!e.target.checked) {
      setYearStart('')
      setYearEnd('')
    }
  }

  const handleStartYearChange = (e) => {
    readySetYearEndList(e.target.value)
    setYearStart(e.target.value)
    setYearEnd(e.target.value)
  }
  const handleEndYearChange = (e) => {
    setYearEnd(e.target.value)
  }

  return (
    <div className='petrol-container'>
      <div className='petrol-filter flex align-items-center' style={{ marginBottom: '1em' }}>
        <FormControlLabel
          control={<Switch checked={isFilter} onChange={handleSwitchChange} />}
          label="筛选"
          labelPlacement="bottom"
        />
        <div style={{ width: '1em' }}></div>
        <div className='year-start'>
          <CustomSelect
            id="year-start"
            width={70}
            value={yearStart}
            label="Start"
            itemList={yearStartList}
            onChange={handleStartYearChange}
            disabled={!isFilter}
          />
        </div>
        <div className='year-end'>
          <CustomSelect
            id="year-end"
            width={70}
            value={yearEnd}
            label="End"
            itemList={yearEndList}
            onChange={handleEndYearChange}
            disabled={!isFilter || !yearStart}
          />
        </div>
        <div style={{ width: '1.5em' }}></div>
        <div>加油<b>{totalCount}</b>次，</div>
        <div>应付: <b>￥{totalPricePayable}</b>，</div>
        <div>实付: <b>￥{totalPricePayactual}</b></div>
      </div>
      <div className='petrol-echarts flex'>
        <div id={echartsPetrolPrice} style={{ flex: 1, height: '20em' }}></div>
        <div id={echartsPetrolPayment} style={{ flex: 1, height: '20em' }}></div>
      </div>
    </div>
  )
}

export default MainPagePetrolECharts
